import Ajv from "ajv";

const standardValidator = data => {
  const ajv = new Ajv(); // options can be passed, e.g. {allErrors: true}

  let standardSchema = {
    $id: "/Timeline",
    $schema: "http://json-schema.org/schema#",
    type: "object",
    properties: {
      definition: {
        type: "object",
        properties: {
          types: {
            type: "array",
            items: { $ref: "#/definitions/type" }
          },
          properties: {
            type: "array",
            items: { $ref: "#/definitions/property" }
          },
          relationshipTypes: {
            type: "array",
            items: { $ref: "#/definitions/relationshipType" }
          },
          isRelative: { type: "boolean" },
          relativeUnits: {
            oneof: [
              { type: "null" },
              {
                type: "string",
                enum: [
                  "nanoseconds",
                  "microseconds",
                  "milliseconds",
                  "seconds",
                  "minutes",
                  "hours",
                  "days",
                  "weeks",
                  "months",
                  "years"
                ]
              }
            ]
          },
          timescale: {
            oneof: [{ type: "null" }, { type: "string", enum: ["UTC", "TAI", "TCB", "TT", "TCG", "TDB", "TDT", "ET"] }]
          }
        },
        required: ["types"]
      },
      data: {
        type: "object",
        properties: {
          items: {
            type: "array",
            items: { $ref: "#/definitions/item" },
            minItems: 1
          },
          relationships: {
            type: "array",
            items: { $ref: "#/definitions/relationship" }
          }
        }
      },
      applicableDate: { type: "string" },
      language: { oneof: [{ type: "null" }, { type: "string" }] },
      "@context": { oneof: [{ type: "null" }, { type: "string" }] }
    },
    required: ["definition", "data", "applicableDate"],
    definitions: {
      type: {
        $id: "/Type",
        type: "object",
        properties: {
          id: { type: "string" },
          label: { type: "string" },
          pluralLabel: { type: "string" },
          hasDates: { oneof: [{ type: "null" }, { type: "boolean" }] },
          superTypes: { oneof: [{ type: "null" }, { type: "array", items: { type: "string" } }] },
          properties: { oneof: [{ type: "null" }, { type: "array", items: { type: "string" } }] },
          relationshipTypes: { oneof: [{ type: "null" }, { type: "array", items: { type: "string" } }] },
          isLocation: { oneof: [{ type: "null" }, { type: "boolean" }] }
        },
        required: ["id", "label", "pluralLabel"]
      },
      property: {
        $id: "/Property",
        type: "object",
        properties: {
          id: { type: "string" },
          label: { type: "string" },
          dataFormat: { type: "string", enum: ["string", "number", "boolean"] },
          allowedValues: {
            oneof: [{ type: "null" }, { type: "string" }, { type: "array", items: { type: "string" } }]
          },
          multiple: { oneof: [{ type: "null" }, { type: "boolean" }] }
        },
        required: ["id", "label", "dataFormat"]
      },
      relationshipType: {
        $id: "/RelationshipType",
        type: "object",
        properties: {
          id: { type: "string" },
          label: { type: "string" },
          types: { type: "array", items: { type: "string" } },
          multiple: { oneof: [{ type: "null" }, { type: "boolean", items: { type: "string" } }] }
        },
        required: ["id", "label", "types"]
      },
      item: {
        $id: "/Item",
        type: "object",
        properties: {
          id: { type: "string" },
          type: { type: "string" },
          label: { type: "string" },
          locationUri: { oneof: [{ type: "null" }, { type: "string" }] },
          start: { oneof: [{ type: "null" }, { type: "string" }, { type: "number" }] },
          end: { oneof: [{ type: "null" }, { type: "string" }, { type: "number" }] },
          ongoing: { oneof: [{ type: "null" }, { type: "boolean" }] },
          latestStart: { oneof: [{ type: "null" }, { type: "string" }, { type: "number" }] },
          earliestEnd: { oneof: [{ type: "null" }, { type: "string" }, { type: "number" }] },
          super: { oneof: [{ type: "null" }, { type: "string" }] },
          propertValues: { oneof: [{ type: "null" }, { type: "object" }] }
        },
        required: ["id", "type", "label"]
      },
      relationship: {
        $id: "/Relationship",
        type: "object",
        properties: {
          id: { type: "string" },
          subject: { type: "string" },
          relationshipType: { type: "string" },
          target: { type: "string" }
        },
        required: ["id", "subject", "relationshipType", "target"]
      }
    }
  };

  const validate = ajv.compile(standardSchema);
  const valid = validate(data);
  //if (!valid) console.log(validate.errors);

  return valid;
};

export default standardValidator;
